export enum PortionSize {
  Five = 5,
  Ten = 10,
  TwentyFive = 25,
  Fifty = 50,
  OneHundred = 100,
  TwoHundredFifty = 250,
  FiveHundred = 500,
}
